import { render } from "./form4.vue?vue&type=template&id=32b6563e&scoped=true"
import script from "./form4.vue?vue&type=script&lang=js"
export * from "./form4.vue?vue&type=script&lang=js"

import "./form4.vue?vue&type=style&index=0&id=32b6563e&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b6563e"]])

export default __exports__